module.exports = __webpack_public_path__ + "img/presidentialsweet_room_image05.c4615aa9.jpg";